/*
 * LrnDialog — the anchored settings dialog, on the Phase 4 chassis (D18: ANCHORED).
 *
 * Deliberately NOT a modal (decision D18, 2026-07-13, reaffirming this file's older
 * comment): a small popover anchored next to its opener button, no backdrop, the page
 * under it stays live. PL.layers owns dismissal — Esc (consumed) and outside
 * pointerdown close it, and the outside press still lands where it was aimed
 * (dismiss-and-act, same as the app's menus). PL.focus hands focus back to the opener
 * when the closing dialog held it. The old document-level click/keydown dances are
 * gone with the rest of the legacy self-dismissal plumbing.
 *
 * open(anchor) takes the opener element: it joins the layer's anchors, so the press
 * on the very button that opened (or re-anchors) the dialog never dismiss-then-reopens.
 */
var LrnDialog;

$(function () {

	LrnDialog = function (buttonObj, dialog, params) {
		var that = this;

		if (params.draggable) {
			PL.drag.attach(dialog[0]);
			dialog.find(".dlgHeaderClass").addClass("cursorMove");
		}

		if (params.title) {
			this.title = getRes(params.title);
			dialog.find(".dlgHeaderTitleClass").text(this.title);
		} else {
			this.title = dialog.find(".dlgHeaderTitleClass").text();
		}
		this.actionUrl = params.actionUrl;

		var okButton = dialog.find(".dlgOkButton");
		var cancelButton = dialog.find(".dlgCancelButton");
		var headerCloseButton = dialog.find(".dlgHeaderCloseClass");

		var tip = PL.tip.create();

		var layerHandle = null;
		var focusToken = null;

		this.getDialog = function () {
			return dialog;
		};

		function okHandler(e) {
			var res = buttonObj.onOk(e);
			if (res) {
				that.close(e);
			}
		}

		function pushLayer(anchor) {
			return PL.layers.push({
				el: dialog[0],
				anchors: anchor ? [anchor] : [],
				onClose: function (reason) {
					// Legacy Esc two-step: a shown validation tip absorbs the first
					// Escape — hide it and keep the dialog up (the entry is already
					// popped, so re-push; the next Esc reaches the dialog itself).
					if (reason === "esc" && tip.isShown) {
						tip.hide();
						layerHandle = pushLayer(anchor);
						return;
					}
					layerHandle = null;
					dialog.hide();
					if (buttonObj.onClose) {
						buttonObj.onClose();
					}
					if (focusToken) {
						focusToken.restore({ ifWithin: dialog[0] });
					}
				}
			});
		}

		this.open = function (anchor) {
			if (layerHandle) {
				// Re-click on the opener while open: legacy kept the dialog up
				// (the anchor makes the manager leave the press alone; nothing to do).
				if (buttonObj.onOpen) {
					buttonObj.onOpen();
				}
				return;
			}
			focusToken = PL.focus.remember();
			dialog.show();
			layerHandle = pushLayer(anchor);
			if (buttonObj.onOpen) {
				buttonObj.onOpen();
			}
		};

		this.close = function (e) {
			if (layerHandle) {
				layerHandle.close();
			}
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		this.showTip = function (msg) {
			tip.show(msg);
		};

		this.hideTip = function () {
			tip.hide();
		};

		init();

		function init() {
			dialog.find("input").keydown(function (e) {
				if (e.which == PL.keys.ENTER) {   // Enter commits, like OK
					okHandler(e);
					e.preventDefault();
					e.stopPropagation();
				}
			});

			// Clicks inside the dialog must not reach document-level handlers (legacy parity;
			// the layer manager itself keys on pointerdown containment, not this).
			dialog.click(function (e) {
				e.stopPropagation();
			});

			cancelButton.click(that.close);
			headerCloseButton.click(that.close);
			okButton.click(okHandler);
		}
	}
});
